<script setup lang="ts">
/**
 * UI-kit component
 * Category: Fields
 * Name: TzSelect
 */
import VueSelect from 'vue-select'

import type { TzSelectProps } from '@UI/Fields/TzSelect/types/interfaces'

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { useTzSelect } from '@UI/Fields/TzSelect/composables/use-tz-select.hook'
import { IconContainer } from '@UI/Other/IconContainer'

defineOptions({
  name: 'TzSelect',
})

const props = withDefaults(defineProps<TzSelectProps>(), {
  value: 'UTC',
  noOptions: 'Time zone not found',
  disabled: false,
})

const emit = defineEmits<{
  'option:selected': [string]
}>()

const {
  refValue,
  handleSelect,
} = useTzSelect({
  props,
  onSelect: (value: string) => emit('option:selected', value),
})
</script>

<template>
  <VueSelect
    id="tzSelect"
    v-model="refValue"
    class="tz-select"
    :class="{ 'opacity-75': disabled }"
    :disabled="disabled"
    :options="timezones"
    @option:selected="handleSelect"
  >
    <template #no-options>
      <span class="vs__no-options">
        {{ noOptions }}
      </span>
    </template>
    <template #open-indicator>
      <div class="vs__arrow">
        <IconContainer>
          <FontAwesomeIcon :icon="faChevronDown" />
        </IconContainer>
      </div>
    </template>
  </VueSelect>
</template>

<style lang="scss" scoped src="../styles/_tz-select.scss" />
